import UserProfileHeader from "../../../AdminPanel/userProfile/userProfileHeader";

const Profile = () => {
  return <UserProfileHeader />;
};

export default Profile;
